import { render, staticRenderFns } from "./favourite_product.vue?vue&type=template&id=10aaca24&scoped=true&"
import script from "./favourite_product.vue?vue&type=script&lang=js&"
export * from "./favourite_product.vue?vue&type=script&lang=js&"
import style0 from "./favourite_product.vue?vue&type=style&index=0&id=10aaca24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaca24",
  null
  
)

export default component.exports